export function createTasksApi(http) {
  return {
    create: (milestoneId, body) => http.post(`/api/milestones/${milestoneId}/tasks`, body),
    patch: (id, body) => http.patch(`/api/tasks/${id}`, body),
    remove: (id) => http.del(`/api/tasks/${id}`),
    markDone: (id) => http.post(`/api/tasks/${id}/done`),
    markUndone: (id) => http.del(`/api/tasks/${id}/done`),
    reorder: (milestoneId, order) =>
      http.patch(`/api/milestones/${milestoneId}/tasks/reorder`, { order }),
  }
}
